import { render, staticRenderFns } from "./DadosFalecimentoSV.vue?vue&type=template&id=637721da&"
import script from "./DadosFalecimentoSV.vue?vue&type=script&lang=js&"
export * from "./DadosFalecimentoSV.vue?vue&type=script&lang=js&"
import style0 from "./DadosFalecimentoSV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports